import request from '@/utils/request'
// import Qs from 'qs'

export function getDepartments() {
  return request({
    url: '/user/departments',
    method: 'get'
  })
}

export function getDepUsers(params) {
  return request({
    url: '/user/users',
    method: 'get',
    params
  })
}

export function getRegionList(params) {
  return request({
    url: '/user/region',
    method: 'get',
    params
  })
}

// export function getDepAuth(params) {
//   return request({
//     url: '/user/department',
//     method: 'get',
//     params,
//     paramsSerializer: function(params) {
//       return Qs.stringify(params, { arrayFormat: 'repeat' })
//     }
//   })
// }

export function getDepAuth(data) {
  return request({
    url: '/user/department',
    method: 'post',
    tips: 0,
    data
  })
}

export function userAuthorize(data) {
  return request({
    url: '/user/authorize',
    method: 'post',
    data
  })
}

export function userAuthorizeReset(data) {
  return request({
    url: '/user/clean',
    method: 'post',
    data
  })
}
